import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';

import { fetchPermissionaryVehicles } from 'app/store/slices/line';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import DefaultTable from '../../components/DefaultTable';
import PageWrapper from '../../components/PageWrapper';
import SaveBox from '../../components/SaveBox';

import { vehicleDrawerColumns } from '../../table-configs/columns-schemas';
import SimpleAlert from '../../components/SimpleAlert';
import { FormControl, Grid, InputLabel, FilledInput, InputAdornment } from '@material-ui/core';
import Search from '@material-ui/icons/Search';
import helpers from 'app/utils/helpers';

const FindVehicle = ({ onClose, onSave, permissionaryDocument }) => {
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);

    const [selectedTempVehicles, setSelectedTempVehicles] = useState(null);
    const [vehicleTableRows, setVehicleTableRows] = useState([]);
    const [alertMessage, setAlertMessage] = useState(null);

    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    const [orderBy, setOrderBy] = useState('nmProprietario');
    const [orderDirection, setOrderDirection] = useState('desc');

    const lineVehicles = useSelector((state) => state.line.lineVehicles);
    const inspectedVehicles = useSelector((state) => state.line.permissionaryInspectedVehicles);

    const [filters, setFilters] = useState(() => {
        return {
            campoOrdenacao: orderBy,
            direcaoOrdenacao: orderDirection,
        };
    });

    useEffect(() => {
        (async () => {
            setLoading(true);
            const deCpfCnpj = helpers.somenteAlfanumericos(permissionaryDocument);
            await dispatch(fetchPermissionaryVehicles({ page, size: pageSize, deCpfCnpj }));
            setLoading(false);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    useEffect(() => {
        const selectedVehiclesId = lineVehicles?.filter((v) => !v.boExcluido).map((v) => v.cdVeiculo);
        const checkedPermiVehicles = inspectedVehicles?.content.map((v) => {
            if (selectedVehiclesId.includes(v.cdVeiculo)) {
                return { ...v, checked: true, lockCheckbox: true };
            } else {
                return v;
            }
        });
        setVehicleTableRows(checkedPermiVehicles);
    }, [lineVehicles, inspectedVehicles]);

    const handleSelectVehicle = ({ data }) => {
        const temp = { veiculo: data, boAtivo: true, cdVeiculo: data?.cdVeiculo };
        setSelectedTempVehicles(temp);
    };

    // const handleSaveSelected = () => {
    //   if (!selectedTempVehicles) {
    //     setAlertMessage('Selecione um veículo para adicionar ao permissionário.');
    //   } else {
    //     const tempOldData = _.cloneDeep(lineVehicles);
    //     const tempNewData = _.cloneDeep(selectedTempVehicles);
    //     dispatch(setLineVehicles([...tempOldData, tempNewData]));
    //
    //     onClose();
    //   }
    // };
    const handleSaveSelected = () => {
        if (!selectedTempVehicles) {
            setAlertMessage('Selecione um veículo para adicionar ao permissionário.');
        } else {
            const tempNewData = _.cloneDeep(selectedTempVehicles);
            if (onSave) {
                onSave(tempNewData);
            }
            onClose();
        }
    };

    const handleChangePageSize = (e) => {
        setPage(0);
        setPageSize(parseInt(e.target.value));
    };

    const handleChangePage = (e, page) => {
        setPage(page);
    };

    const handleChangeOrder = (event, property) => {
        let tempDirection = orderDirection;
        if (property === orderBy) {
            tempDirection = orderDirection === 'desc' ? 'asc' : 'desc';
        }
        const temp = { ...filters };
        temp['campoOrdenacao'] = `${property}`;
        temp['direcaoOrdenacao'] = tempDirection;
        setOrderDirection(tempDirection);
        setOrderBy(property);
        setFilters(temp);
        setPage(0);
    };

    const handleBlurSearch = (event) => {
        const temp = { ...filters };
        temp['txtBusca'] = event.target.value;
        setFilters(temp);
        setPage(0);
    };

    return (
        <>
            <PageWrapper
                maxWidth="md"
                title="Adicionar veículo"
                isPlain
                actionButton={
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                }>
                <Grid item xs={12} container spacing={4}>
                    <Grid item xs={4}>
                        <FormControl size="small" variant="filled" fullWidth>
                            <InputLabel>Buscar</InputLabel>
                            <FilledInput
                                id="outlined-adornment-weight"
                                defaultValue={''}
                                onBlur={handleBlurSearch}
                                onChange={() => {}}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <Search />
                                    </InputAdornment>
                                }
                                aria-describedby="outlined-weight-helper-text"
                                inputProps={{
                                    'aria-label': 'weight',
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={8}></Grid>

                    <Grid item xs={12}>
                        <DefaultTable
                            loading={loading}
                            columns={vehicleDrawerColumns}
                            // rows={inspectedVehicles?.content}
                            rows={vehicleTableRows}
                            entryProps={{
                                onChangeSelect: handleSelectVehicle,
                                selectedId: selectedTempVehicles?.cdVeiculo,
                            }}
                            paginationProps={{
                                onPageChange: handleChangePage,
                                onRowsPerPageChange: handleChangePageSize,
                                page: page,
                                rowsPerPage: pageSize,
                                rowsPerPageOptions: [5, 10, 25],
                                count: inspectedVehicles?.totalElements || 0,
                            }}
                            orderBy={orderBy}
                            order={orderDirection}
                            onRequestSort={handleChangeOrder}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <SaveBox
                            firstButtonLabel="Voltar"
                            middleButtonLabel="Adicionar"
                            onSave={handleSaveSelected}
                            onCancel={onClose}
                        />
                    </Grid>
                </Grid>
            </PageWrapper>
            <SimpleAlert open={!!alertMessage} onClose={() => setAlertMessage(null)}>
                {alertMessage}
            </SimpleAlert>
        </>
    );
};

export default FindVehicle;
